import { Injectable } from '@angular/core';

export interface MinioImageItem {
  name: string;
  objectPath: string;
  url: string;
  size: number;
  lastModified?: string | Date;
}

@Injectable({ providedIn: 'root' })
export class JkMinioService {

  async uploadFile(host: string, path: string, file: File): Promise<MinioImageItem> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${host}/minio/upload?path=${encodeURIComponent(path)}`;
    const res = await fetch(url, { method: 'POST', body: formData });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || '上傳失敗');
    }
    const result = await res.json();
    return {
      name: result.originalname as string,
      objectPath: result.objectPath as string,
      url: result.url as string,
      size: result.size as number,
    };
  }

  async uploadImage(host: string, path: string, file: File): Promise<string> {
    const result = await this.uploadFile(host, path, file);
    return result.url;
  }

  async listFiles(host: string, path: string): Promise<MinioImageItem[]> {
    const url = `${host}/minio/list?path=${encodeURIComponent(path)}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error('列表取得失敗');
    return await res.json();
  }

  async listImages(host: string, path: string): Promise<MinioImageItem[]> {
    return this.listFiles(host, path);
  }

  async deleteFile(host: string, objectPath: string): Promise<void> {
    const url = `${host}/minio/file?filePath=${encodeURIComponent(objectPath)}`;
    const res = await fetch(url, { method: 'DELETE' });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || '刪除失敗');
    }
  }
}
